<template>
    <div class="vuw-progress">
        <span class="value" :style="{width: `${progressValue}%`}"></span>
    </div>
</template>

<script>
export default {
    props: {
        progressValue: {
            type: Number,
            required: true,
            default: 0,
            validator: (value) => value >= 0 && value <= 100,
        },
    }
}
</script>